import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum SpecialSubjects {
  No = 'no',
  SubrecipientIrbOrIacuc = 'subrecipient-irb-or-iacuc',
  EmbryonicStemCells = 'embryonic-stem-cells',
  SponsorMustApprove = 'sponsor-must-approve',
  UsingPrimeIrbOrIacuc = 'using-prime-irb-or-iacuc',
}

const SUBCONTRACT_PERCENTS: ReadonlySet<SpecialSubjects> = new Set(
  Object.values(SpecialSubjects) as SpecialSubjects[],
)
export namespace SpecialSubjects {
  export const ALL: readonly SpecialSubjects[] =
    Array.from(SUBCONTRACT_PERCENTS)
  export const isSpecialSubjects =
    TypeChecker.Factory.oneOf(SUBCONTRACT_PERCENTS)
  export const assertIsSpecialSubjects: TypeAsserter<SpecialSubjects> =
    TypeAsserter.Factory.from(isSpecialSubjects)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link SpecialSubjects}
   */
  export function getEntry(
    specialSubjects: SpecialSubjects,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[specialSubjects], id: specialSubjects }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    SpecialSubjects,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [SpecialSubjects.No]: { name: 'No' },
    [SpecialSubjects.SubrecipientIrbOrIacuc]: {
      name: 'Human or Animal Subjects approved by Subrecipient IRB or IACUC',
    },
    [SpecialSubjects.EmbryonicStemCells]: {
      name: 'Embryonic stem cells',
    },
    [SpecialSubjects.SponsorMustApprove]: {
      name: 'Sponsor must approve',
    },
    [SpecialSubjects.UsingPrimeIrbOrIacuc]: {
      name: 'Subrecipient using Prime Recipient’s IRB or IACUC',
    },
  }
}
